export const pause = async (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const delay = async (fn, ms) => {
	await pause(ms)
	await fn()
}

export const shuffle = (a) => {
	for (let i = a.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[a[i], a[j]] = [a[j], a[i]];
	}
	return a;
}



// WEBPACK FOOTER //
// ./src/utils/index.js